// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/28e3b17e03bc0f64657f.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"a0f6882039ec427f9ed2","130":"d1413650c069b4e31d15","131":"b49399b9eb1c026135b5"}[chunkId] + ".chunk.js";
};